<div class="exercise-preview-container">
    <div class="exercise-questions">
        @if (exercice?.questions && exercice.questions.length > 0) {
            <h4 class="questions-title">Questions ({{ exercice.questions.length }})</h4>
            @for (question of exercice.questions; track question.id; let i = $index) {
                <div class="question-block">
                    <div class="question-header">
                        <span class="question-index">Q{{ i + 1 }}</span>
                        <div class="question-label" [innerHTML]="question.label"></div>
                    </div>

                    @if (question.media?.media_type === 'image') {
                        <div class="question-media">
                            <img class="question-img" [src]="question.media.url" alt="Question image" />
                        </div>
                    }
                    @if (question.media?.media_type === 'video') {
                        <div class="question-media">
                            <youtube-player [videoId]="question.media.url" suggestedQuality="highres" [width]="400"></youtube-player>
                        </div>
                    }

                    @if (question.answers_choices && question.answers_choices.length > 0) {
                        <div class="answers-list">
                            @for (choice of question.answers_choices; track choice.id) {
                                <div class="answer-choice" [ngClass]="{'correct-answer': choice.is_right, 'wrong-answer': !choice.is_right}">
                                    <span class="answer-icon">
                                        <mat-icon>{{ choice.is_right ? 'check_circle' : 'cancel' }}</mat-icon>
                                    </span>
                                    <span class="answer-text" [innerHTML]="choice.text"></span>
                                </div>
                            }
                        </div>
                    }

                    @if (question.content && exerciceService.getContentValueByTypeContent('explanation', question.content)) {
                        <div class="explanation-block">
                            <div class="explanation-title">Explanation</div>
                            <div class="explanation-content" [innerHTML]="exerciceService.getContentValueByTypeContent('explanation', question.content)"></div>
                        </div>
                    }
                </div>
            }
        } @else {
            <p class="no-questions">No questions available for this exercise.</p>
        }
    </div>
</div>
